import { Play, Send } from "lucide-react";
import { Link } from "react-router-dom";

import { buttonVariants } from "@/components/ui/button";

/**
 * The project page's action row: the two ways to start a run (fs#1797).
 *
 * Each action is ONE element — a `<Link>` carrying the button recipe as a
 * class string. It used to be a `<Button>` wrapped in a `<Link>`: a `<button>`
 * nested in an `<a>`, which is invalid HTML and two tab stops (announced as a
 * link, then as a button) for a single action.
 *
 * Props-only, no store or query coupling, so it can move to `flowstack-ui`
 * unchanged. The paths are the app's route table, not a new contract.
 */
export interface ProjectActionsProps {
  /** Project slug — every submission route is project-scoped. */
  slug: string;
}

export function ProjectActions({ slug }: ProjectActionsProps): JSX.Element {
  return (
    <>
      {/* The PRIMARY affordance (#525): a first-time user reaches a runnable
          pipeline from the overview without knowing the picker → Submit a
          Flow path. Keep it primary; the picker is the secondary entry. */}
      <Link to={`/projects/${slug}/submit/flow`} className={buttonVariants()}>
        <Play className="mr-2 h-4 w-4" aria-hidden />
        Run an AFFDO pipeline
      </Link>
      {/* The general entry: the picker offers a Tile or a Flow. */}
      <Link to={`/projects/${slug}/submit`} className={buttonVariants({ variant: "outline" })}>
        <Send className="mr-2 h-4 w-4" aria-hidden />
        Submit a run
      </Link>
    </>
  );
}
